import React from "react";
import { Image, isPDF } from "@sonder/ui/source/styled/components/Image";
import { ImageSlide } from "@sonder/ui/source/styled/components/ImageSlide";
import { VideoPlayer } from "@sonder/ui/source/styled/components/VideoPlayer";
import { VideoPlayerSlide } from "@sonder/ui/source/styled/fragments/VideoPlayerSlide";
import { TaskAttachment } from "core/queries/GetTaskComments";
import { Resource } from "typings/globalGQLTypes";

interface AttachmentProps {
  attachments: TaskAttachment[] | null;
}

const renderVideoAttacment = (attachment: TaskAttachment) => {
  const { url } = attachment;
  const posterUrl = `${url.slice(0, url.lastIndexOf("."))}.jpg`;
  return (
    <VideoPlayerSlide key={attachment.id}>
      <VideoPlayer controls poster={posterUrl} src={url} />
    </VideoPlayerSlide>
  );
};

const renderPhotoAttachment = (attachment: TaskAttachment) => (
  <ImageSlide isPDF={isPDF(attachment.url) || undefined} key={attachment.id}>
    <Image src={attachment.url} />
  </ImageSlide>
);

const renderAttachment = (attachment: TaskAttachment) => {
  switch (attachment.resourceType) {
    case Resource.video:
      return renderVideoAttacment(attachment);
    case Resource.image:
      return renderPhotoAttachment(attachment);
    default:
      return null;
  }
};

export const Attachments = ({ attachments }: AttachmentProps) => {
  const attachmentNodes = (attachments || [])
    .map(renderAttachment)
    .filter(attachment => !!attachment);

  if (!attachmentNodes || !attachmentNodes.length) {
    return null;
  }

  return <>{attachmentNodes}</>;
};
